import { Clock, DollarSign, Gift } from 'react-feather'
import { match } from 'ts-pattern'
import { TransactionType } from '@/types/transaction'
import { IconContainer } from './IconContainer'

/** Gift for credits, $ for redemptions, clock for expirations */
export const TransactionIcon = ({ type }: { type: TransactionType | null }) =>
  match(type)
    .with('redeem', () => (
      <IconContainer
        icon={DollarSign}
        bgColor="bg-green-100"
        textColor="text-green-700"
      />
    ))
    .with('expire', () => (
      <IconContainer
        icon={Clock}
        bgColor="bg-gray-200"
        textColor="text-gray-900"
      />
    ))
    .otherwise(() => (
      <IconContainer
        icon={Gift}
        bgColor="bg-purple-100"
        textColor="text-purple-700"
      />
    ))
